/**
 * Tarifas Bancárias Transferências
 * (prototype: erpone_tarifas_banc_rias_transfer_ncias)
 *
 * Contrato: GET /finance/bank-tariffs?channel=TRANSFER → PaginatedResponseDto<BankTariffResponseDto>
 */
import { BankTariffsChannelPage } from './BankTariffsChannelPage';

export function BankTariffsTransferPage(): JSX.Element {
  return (
    <BankTariffsChannelPage
      channel="TRANSFER"
      title="Tarifas Bancárias — Transferências"
      subtitle="Tarifas por serviço/evento de transferência (TED, DOC...)."
    />
  );
}